import { render, staticRenderFns } from "./query-sales-by-month.vue?vue&type=template&id=37bfc588&scoped=true&"
import script from "./query-sales-by-month.vue?vue&type=script&lang=js&"
export * from "./query-sales-by-month.vue?vue&type=script&lang=js&"
import style0 from "./query-sales-by-month.vue?vue&type=style&index=0&id=37bfc588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bfc588",
  null
  
)

export default component.exports